import type { FetchBaseQueryError, QueryReturnValue } from '@reduxjs/toolkit/query'
import type { PaginatedResponse } from '@/types/api'

type Q = QueryReturnValue<unknown, FetchBaseQueryError, unknown>
type Base = (arg: string) => Q | PromiseLike<Q>

/** Сколько брать за запрос. Сервер по умолчанию отдаёт 10 — из-за этого «Мои курсы»
 *  показывали только первые 10 курсов, а после удаления «появлялся» 11-й. */
const LIMIT = 50
/** Страховка от бесконечного цикла на неверном `pages`. */
const MAX_PAGES = 40

/**
 * Забирает ВСЕ страницы постраничного списка автора. Список нужен целиком: фильтры и
 * счётчики «Мои курсы» обязаны считать по всем курсам, а не по загруженной странице.
 */
export const fetchAllPages = async <T>(
  url: string,
  baseQuery: Base,
): Promise<{ data: T[] } | { error: FetchBaseQueryError }> => {
  const items: T[] = []
  for (let page = 1; page <= MAX_PAGES; page++) {
    const sep = url.includes('?') ? '&' : '?'
    const res = await baseQuery(`${url}${sep}page=${page}&limit=${LIMIT}`)
    if (res.error) return { error: res.error }
    const body = res.data as PaginatedResponse<T>
    items.push(...(body.items ?? []))
    if (!body.pages || page >= body.pages) break
  }
  return { data: items }
}
